// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/SuperTokenWallets/index.css
// module id = 2381
// module chunks = 0